import React, { useState, useEffect, useRef } from "react";
import api, { apiRaw } from "../../services/api";
import { motion } from "framer-motion";

import { setToken } from "../../services/managerToken";
import criptografaSenha from "../../helpers/criptografaSenha";
import tremerComponent from "../../helpers/tremerComponent";
import Toastify from "../../components/Toastify";

import {
    Container,
    Content,
    ContentLogin,
    ContentInput,
    Saudacoes,
} from "./styles";
import { Button, InputCheck } from "../../styles/CommonStyles";
import { FaUser, FaKey } from "react-icons/fa";

export default function Auth ( { history } ) {
    const [ isVisible, setIsVisible ] = useState( false );
    const [ loginDTO, setLoginDTO ] = useState( {
        SubscriberEmail: "",
        SubscriberPassword: "",
        Username: '',
        Password: '',
        AssymetricKeyId: '',
        publicKey: "",
        ip: '',
        Mobile: 0,
    } );
    const refContent = useRef( null );
    const refContainerLogin = useRef( null );
    const refInputSenha = useRef( null );
    const refSaudacoes = useRef( null );
    const [ checkLembrarUsuario, setCheckLembrarUsuario ] = useState( false );

    useEffect( () => {
        init();
    }, [] );

    async function init () {

        try {
            const userLembrar = localStorage.getItem( "@med:lembrarUsuario" );
            let response = await api.get( "security/getkeys" );
            setLoginDTO( {
                ...loginDTO,
                AssymetricKeyId: response.data.KeyId,
                publicKey: response.data.PublicKey,
                Username: userLembrar ? userLembrar : ""
            } );
            setCheckLembrarUsuario( true );
        } catch ( error ) {
            console.log( error );

        }
    };

    async function acessar () {
        try {
            if ( checkLembrarUsuario )
                localStorage.setItem( "@med:lembrarUsuario", loginDTO.Username );

            if ( !loginDTO.Username || !loginDTO.Password )
                return Toastify.warning( "Por favor, preencha os campos corretamente." );

            if ( !loginDTO.AssymetricKeyId ) {
                let [ data ] = await api.get( "security/getkeys" );
                setLoginDTO( { ...loginDTO, AssymetricKeyId: data.KeyId, publicKey: data.PublicKey } );
            };

            let { data } = await api.post( 'security/validateuser',
                { ...loginDTO, SubscriberPassword: criptografaSenha( loginDTO.publicKey, loginDTO.SubscriberPassword ) }
            );

            loginAceito( data );

        } catch ( error ) {
            if ( error.response.status === 401 ) {
                Toastify.error( "Dados incorretos, por favor verifique e tente novamente." );
                tremerComponent( refContainerLogin );
            } else {
                Toastify.error( "Ops, ocorreu um erro na sua solicitação" );
            }
        }
    };

    function enter ( e, campo ) {
        if ( e.charCode == 13 || e.keyCode == 13 ) {
            if ( campo == 'email' )
                return refInputSenha.current.focus();
            return acessar();
        }
    };

    function loginAceito ( data ) {
        refContent.current.style.opacity = '0';

        setTimeout( () => {
            refContent.current.style.display = 'none';
            refSaudacoes.current.style.display = 'block';
            setIsVisible( true );
        }, 500 );
        setTimeout( () => {
            setToken( data );
            history.push( "/home" );
        }, 1500 );
    };

    return (
        <Container>
            {/* <img src='https://www.pictureeuropa.com/wp-content/uploads/2019/09/4k-nature-wallpapers-ultra-hd-62.jpg' /> */ }
            <Content ref={ refContent }>
                <ContentLogin ref={ refContainerLogin } >
                    <div style={ { width: "100%" } }>
                        <h3>E-MEDICINE</h3>
                    </div>
                    <form>
                        <ContentInput>
                            <input
                                onKeyPress={ ( e ) => enter( e, 'email' ) }
                                type='text'
                                placeholder='Usuario'
                                defaultValue={ loginDTO.Username }
                                onChange={ event =>
                                    setLoginDTO( { ...loginDTO, Username: event.target.value } )
                                }
                            />
                            <FaUser />
                        </ContentInput>
                        <ContentInput>
                            <input
                                ref={ refInputSenha }
                                onKeyPress={ ( e ) => enter( e, 'senha' ) }
                                type='password'
                                placeholder='Senha'
                                defaultValue=''
                                onChange={ event =>
                                    setLoginDTO( { ...loginDTO, Password: criptografaSenha( loginDTO.publicKey, event.target.value ) } )
                                }
                            />
                            <FaKey />
                        </ContentInput>
                        <div>
                            <InputCheck style={ { display: "inline-block" } }>
                                <label htmlFor='Padrao'>Lembrar Usuário</label>
                                <input
                                    id='Padrao'
                                    type='checkbox'
                                    checked={ checkLembrarUsuario }
                                    onChange={ event =>
                                        setCheckLembrarUsuario( event.target.checked )
                                    }
                                />
                                <span></span>
                            </InputCheck>
                            <a href='#'>Esqueceu sua senha?</a>
                        </div>
                        <Button
                            onClick={ acessar }
                            style={ {
                                marginTop: "15px",
                                justifyContent: "center",
                                background: "#3a70e8"
                            } }
                        >
                            Acessar
                        </Button>
                    </form>
                </ContentLogin>
            </Content>
            <motion.div animate={ { opacity: isVisible ? 1 : 0, scale: isVisible ? 1 : .8 } } transition={ { type: "spring", ease: "easeOut", duration: 2 } } >
                <Saudacoes ref={ refSaudacoes }>Bem-Vindo</Saudacoes>
            </motion.div>
        </Container>
    );
}
